import type { RefundInfo } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useMutation } from '@apollo/client'

export interface RefundPosition {
  id: GQL_ID
  amount: number
  markCodes?: string[]
}

export interface PlaceOrderMutationResult {
  refundInfo: RefundInfo
}

export interface PlaceOrderMutationVariables {
  refundInfo: {
    orderId: GQL_ID
    positions?: RefundPosition[]
    refundMethod?: string
    returnToShop?: boolean
    fullRefund?: boolean
    returnDeliveryCost?: boolean
  }
}

const GQL_MUTATION_REFUND_POSITION = gql`
  mutation ($refundInfo: RefundInfoInput) {
    refundInfo: refundPositions(refundInfo: $refundInfo) {
      id
      total
      deliveryTotal
      type
      isReturnedToShop
      isRefundedBeforeOrderClosing
      orderStatusOnRefund
    }
  }
`

export const useMutateRefundPositions = () =>
  useMutation<PlaceOrderMutationResult, PlaceOrderMutationVariables>(
    GQL_MUTATION_REFUND_POSITION
  )
